import { settings } from '../../engine/core/settings';

const KEY = 'innerworlds.shadersReady';

interface Saved {
  build: string;
  worlds: string[];
}

/**
 * Worlds whose shaders this browser has compiled, as "quality/scene". The browser keeps
 * compiled shaders between visits but won't say so, so we remember it ourselves: per
 * build (a new build can change the shaders) and per quality (each compiles different ones).
 */
function read(): string[] {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) ?? 'null') as Saved | null;
    return saved?.build === __BUILD_ID__ ? saved.worlds : [];
  } catch {
    return [];
  }
}

/** Has this browser compiled `scene`'s shaders at the current quality in this build? */
export function shadersReady(scene: string): boolean {
  return read().includes(`${settings.quality}/${scene}`);
}

export function markShadersReady(scene: string): void {
  const worlds = read();
  const id = `${settings.quality}/${scene}`;
  if (worlds.includes(id)) return;
  worlds.push(id);
  try {
    localStorage.setItem(KEY, JSON.stringify({ build: __BUILD_ID__, worlds }));
  } catch {
    // storage unavailable: the still menu shows every time
  }
}
